import type { Customer } from '@/stores/account/stores'
import type { Cart } from '@/types/shopify'
import { type FC, useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { RewardsCustomPointsRedemption } from './RewardsCustomPointsRedemption'

interface RewardsWidgetProps {
  token?: string
  customer: Customer | null
  hasFreeProduct: boolean
  hasPaidProduct: boolean
  cart: Cart | null
  checkForProductDetails: any
  cartPoints: number
  scriptUrl: string
  scriptCode: string
  redemptionOptionId?: number
}

export const RewardsWidget: FC<RewardsWidgetProps> = ({
  customer,
  hasFreeProduct,
  hasPaidProduct,
  token,
  cart,
  cartPoints,
  scriptCode,
  scriptUrl,
  redemptionOptionId,
}) => {
  const resolve = useCallback(() => {
    if (redemptionOptionId) {
      const container = document.querySelector('.yotpo-loyalty-page-container')
      // There are 6 divs in container, insert div at index 5
      const div = document.createElement('div')
      div.setAttribute('id', 'rewards-container')

      //I want to append at index 3
      container?.insertBefore(div, container.childNodes[3])
      ReactDOM.render(
        <div>
          <RewardsCustomPointsRedemption
            redemptionOptionId={redemptionOptionId}
          />
        </div>,
        div,
      )
    }
  }, [redemptionOptionId])

  useEffect(() => {
    const head = document.querySelector('head')
    const script = document.createElement('script')

    const url = scriptUrl
    script.setAttribute('src', url)
    head?.appendChild(script)

    window.addEventListener('yotpoCampaignWidgetFinishedLoading', resolve)
  }, [])

  return (
    <>
      {(customer?.email && (
        <div>
          <>
            <div
              id="swell-customer-identification"
              data-authenticated="true"
              data-email={customer.email}
              data-id={
                customer.id.toString().split('/')[
                  customer.id.toString().split('/').length - 1
                ]
              }
              data-token={token}
              style={{ display: 'none' }}
            ></div>
            <div
              id="yotpo-loyalty-cart-data"
              data-free-product-points="0"
              data-applied-coupon-points={cartPoints}
              data-cart-id={cart?.id}
              data-has-paid-product={hasPaidProduct ? 'true' : 'false'}
              data-has-free-product={hasFreeProduct ? 'true' : 'false'}
            />
            <div id="yotpo-loyalty-checkout-data" cart-subtotal-cents="0"></div>
          </>
          <div />
          <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id={scriptCode}
          ></div>
        </div>
      )) || (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={scriptCode}
        ></div>
      )}
    </>
  )
}
